import { faStar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import './ReviewRating.css'
const ReviewRating = () => {
  return (
    <div className="reviewRating">
      <div className="container-fluid px-1 py-5 mx-auto">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-8 col-md-10 col-12 text-center mb-5">
            <div className="card">
              <div className="row justify-content-left d-flex">
                <div className="col-md-4 d-flex flex-column">
                  <div className="rating-box">
                    <h1 className="pt-4">4.0</h1>
                    <p className="">out of 5</p>
                  </div>
                  <div>
                    {" "}
                    <FontAwesomeIcon className="star-active mx-1" icon={faStar}/>
                    <FontAwesomeIcon className="star-active mx-1" icon={faStar}/>
                    <FontAwesomeIcon className="star-active mx-1" icon={faStar}/>
                    <FontAwesomeIcon className="star-active mx-1" icon={faStar}/>
                    <FontAwesomeIcon className="star-inactive mx-1" icon={faStar}/>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="rating-bar0 justify-content-center">
                    <table className="text-left mx-auto">
                      <tr>
                        <td className="rating-label">Excellent</td>
                        <td className="rating-bar">
                          <div className="bar-container">
                            <div className="bar-5"></div>
                          </div>
                        </td>
                        <td className="text-right">123</td>
                      </tr>
                      <tr>
                        <td className="rating-label">Good</td>
                        <td className="rating-bar">
                          <div className="bar-container">
                            <div className="bar-4"></div>
                          </div>
                        </td>
                        <td className="text-right">23</td>
                      </tr>
                      <tr>
                        <td className="rating-label">Average</td>
                        <td className="rating-bar">
                          <div className="bar-container">
                            <div className="bar-3"></div>
                          </div>
                        </td>
                        <td className="text-right">10</td>
                      </tr>
                      <tr>
                        <td className="rating-label">Poor</td>
                        <td className="rating-bar">
                          <div className="bar-container">
                            <div className="bar-2"></div>
                          </div>
                        </td>
                        <td className="text-right">3</td>
                      </tr>
                      <tr>
                        <td className="rating-label">Terrible</td>
                        <td className="rating-bar">
                          <div className="bar-container">
                            <div className="bar-1"></div>
                          </div>
                        </td>
                        <td className="text-right">0</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewRating;
